require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./soluciones-tecnicas-pintura.json") })
        }
      }, "path---soluciones-tecnicas-pintura");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---soluciones-tecnicas-pintura!./.cache/json/soluciones-tecnicas-pintura.json
// module id = 296
// module chunks = 231608221292675